import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ percentage, message, disabled }) => {
  return (
    <div className={`progress-container ${disabled ? 'disabled' : ''}`}>
      <div className="progress-bar" style={{ width: `${percentage}%` }} />
      <div className="progress-message">{message}</div>
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default ProgressBar;
